export const dateFormatter = (value, charReplace = '-') => {
  return new Date(value.replace('/', charReplace))
}
